// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Afm from "../app-core/Afm.bs.js";
import * as React from "react";
import * as NitroAd from "./NitroAd.bs.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";

function AdHorInContent(Props) {
  var renderVisibleOnlyOpt = Props.renderVisibleOnly;
  var renderVisibleOnly = renderVisibleOnlyOpt !== undefined ? renderVisibleOnlyOpt : true;
  Afm.use(undefined);
  var screenSize = ScreenAtom.useNoSSR(undefined);
  var sizes = React.useMemo(function () {
        if (screenSize >= 2) {
          if (screenSize >= 4) {
            return [
                    [
                      300,
                      250
                    ],
                    [
                      320,
                      50
                    ]
                  ];
          } else {
            return [[
                      728,
                      90
                    ]];
          }
        } else {
          return [
                  [
                    970,
                    90
                  ],
                  [
                    728,
                    90
                  ]
                ];
        }
      });
  return React.createElement("div", {
              className: "afm-wrap"
            }, React.createElement("div", {
                  className: "flex items-center justify-center min-w-[320px] min-h-[250px] lg:min-w-[728px] lg:min-h-[90px] xl:min-w-[970px]"
                }, React.createElement(NitroAd.make, {
                      renderVisibleOnly: renderVisibleOnly,
                      id: "na-mid-hor" + (
                        renderVisibleOnly ? "-lzy" : ""
                      ),
                      sizes: sizes
                    })));
}

var make = AdHorInContent;

export {
  make ,
  
}
/* Afm Not a pure module */
